export const FILE_TYPE_REGEX = /^image\/(jpeg|png)$/;
// eslint-disable-next-line no-magic-numbers
export const PROFILE_IMAGE_SIZE_LIMIT = 20 * 1024 * 1024;
export const PROFILE_IMAGE_DIMENSION_LIMIT = 1000;
export const RESIZED_IMG_QUALITY = 100;
export const IMAGE_TYPE_MESSAGE = "Invalid file type. Please select a JPEG or PNG file.";
export const IMAGE_SIZE_MESSAGE = "Image should not exceed 20MB.";
